// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/form_template/v1/form_template.proto (package fingertip.creator.form_template.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateFormTemplateRequest, CreateFormTemplateResponse, DeleteFormTemplateRequest, DeleteFormTemplateResponse, DuplicateFormTemplateRequest, DuplicateFormTemplateResponse, GetFormStatsRequest, GetFormStatsResponse, GetFormTemplatePublicRequest, GetFormTemplatePublicResponse, GetFormTemplateRequest, GetFormTemplateResponse, GetFormTemplatesRequest, GetFormTemplatesResponse, GetSuggestedFormTemplatesRequest, GetSuggestedFormTemplatesResponse, UpdateFormTemplateRequest, UpdateFormTemplateResponse } from "./form_template_pb.js";

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.CreateFormTemplate
 */
export const createFormTemplate = {
  localName: "createFormTemplate",
  name: "CreateFormTemplate",
  kind: MethodKind.Unary,
  I: CreateFormTemplateRequest,
  O: CreateFormTemplateResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.GetFormTemplates
 */
export const getFormTemplates = {
  localName: "getFormTemplates",
  name: "GetFormTemplates",
  kind: MethodKind.Unary,
  I: GetFormTemplatesRequest,
  O: GetFormTemplatesResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.GetSuggestedFormTemplates
 */
export const getSuggestedFormTemplates = {
  localName: "getSuggestedFormTemplates",
  name: "GetSuggestedFormTemplates",
  kind: MethodKind.Unary,
  I: GetSuggestedFormTemplatesRequest,
  O: GetSuggestedFormTemplatesResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.UpdateFormTemplate
 */
export const updateFormTemplate = {
  localName: "updateFormTemplate",
  name: "UpdateFormTemplate",
  kind: MethodKind.Unary,
  I: UpdateFormTemplateRequest,
  O: UpdateFormTemplateResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.GetFormTemplate
 */
export const getFormTemplate = {
  localName: "getFormTemplate",
  name: "GetFormTemplate",
  kind: MethodKind.Unary,
  I: GetFormTemplateRequest,
  O: GetFormTemplateResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.DeleteFormTemplate
 */
export const deleteFormTemplate = {
  localName: "deleteFormTemplate",
  name: "DeleteFormTemplate",
  kind: MethodKind.Unary,
  I: DeleteFormTemplateRequest,
  O: DeleteFormTemplateResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.GetFormTemplatePublic
 */
export const getFormTemplatePublic = {
  localName: "getFormTemplatePublic",
  name: "GetFormTemplatePublic",
  kind: MethodKind.Unary,
  I: GetFormTemplatePublicRequest,
  O: GetFormTemplatePublicResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.GetFormStats
 */
export const getFormStats = {
  localName: "getFormStats",
  name: "GetFormStats",
  kind: MethodKind.Unary,
  I: GetFormStatsRequest,
  O: GetFormStatsResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_template.v1.FormTemplateService.DuplicateFormTemplate
 */
export const duplicateFormTemplate = {
  localName: "duplicateFormTemplate",
  name: "DuplicateFormTemplate",
  kind: MethodKind.Unary,
  I: DuplicateFormTemplateRequest,
  O: DuplicateFormTemplateResponse,
  service: {
    typeName: "fingertip.creator.form_template.v1.FormTemplateService"
  }
};
